<template>
  <div>
    <div class="basketball_level_count" v-loading="loading">
      <ul class="team_name_logo">
        <li>
          <span class="logo">
            <img v-if="matchInfo.home_logo.length > 0" :src="matchInfo.home_logo" />
            <img v-else src="./img/basketball.png" />
          </span>
          <strong>{{ matchInfo.home }}</strong>
        </li>
        <li class="icon_compare">VS</li>
        <li class="last">
          <span class="logo">
            <img v-if="matchInfo.away_logo.length > 0" :src="matchInfo.away_logo" />
            <img v-else src="./img/basketball.png" />
          </span>
          <strong>{{ matchInfo.away }}</strong>
        </li>
      </ul>

      <template v-if="towTeamScore > 0">
        <dl class="basketball_score_count" v-for="(item, index) of scoreList" :key="index" v-if="item">
          <dd >
            <strong>{{ item.home }}</strong>
            <em class="team_red"><span :style="`width: ${$parent.getRatio(item.home, item.away)}%`"></span></em>
          </dd>
          <dt>{{ bballTypes[item.type] }}</dt>
          <dd>
            <em class="team_blue" >
              <span :style="`width: ${$parent.getRatio(item.away, item.home)}%`"></span>
            </em>
            <strong>{{ item.away }}</strong>
          </dd>
        </dl>
      </template>
      <div v-if="towTeamScore == 0 && loading == false">
        <panel-not-data message="当前赛事没有统计数据..." img-name="vs" />
      </div>
    </div>
  </div>
</template>

<script>
//引入公用无数据组件
import PanelNotData from "@/components/match-recommend/not-data";
export default {
  name: "BasketballCounter",
  data() {
    return {
      loading: true,
      //比分统计
      scoreList: [],
      //篮球行为类型
      bballTypes: {
        1: "3分球进球数",
        2: "2分球进球数",
        3: "罚球进球数",
        4: "剩余暂停数",
        5: "犯规数",
        6: "罚球命中率%",
        7: "总暂停数",
      },
      //两队中的各种分值是否全部为0，如果为空，则出现占位图
      towTeamScore: 0,
    };
  },
  components: {
    PanelNotData,
  },
  props: {
    matchInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  mounted() {
    //增加强行关闭动画的定时器
    setTimeout(() => {
      this.loading = false;
    }, 20000);
  },
  methods: {
    /**
     * 处理接收到的数据
     * @param {string} ret_data 接到的数据
     */
    runData(ret_data) {
      // console.log("技术统计内页接到的数据：",ret_data);
      let data_list = JSON.parse(ret_data.replace(/[\\]+/g, "").slice(1, -1));
      // console.log("篮球技术统计数据2：", data_list);
      if (data_list.length == 2 && data_list[1].type == "statsLive") {
        this.scoreList = data_list[1].stats_live;
        console.log("stats_live:",this.scoreList);
        this.scoreList.forEach((res) => {
          //只要有任何一个值大于0，则说明有统计数据
          if (res.home > 0 || res.away > 0) {
            this.towTeamScore++;
          }
        });
      }
      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
//[篮球-技术统计]对应的内容块
.basketball_level_count {
  clear: both;
  width: 100%;
  min-height: 3.5rem;
  overflow: hidden;
  box-sizing: border-box;

  .basketball_score_count {
    display: flex;
    justify-content: space-between;
    clear: both;
    width: 100%;
    height: 0.72rem;
    overflow: hidden;
    box-sizing: border-box;
    padding: 0.2rem 0.5rem;

    dd {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      height: 100%;
      overflow: hidden;
      box-sizing: border-box;
      padding: 0px 10px;

      strong {
        flex-shrink: 0;
        display: block;
        width: 0.7rem;
        overflow: hidden;
        font-size: 0.24rem;
        font-weight: 400;
        color: #333;
      }

      &:last-child {
        strong {
          text-align: right;
        }
      }

      em {
        display: block;
        width: 100%;
        height: 0.08rem;
        overflow: hidden;
        border-radius: 0.05rem;
        background-color: #dddfec;

        span {
          display: block;
          float: left;
          width: 0;
          height: 100%;
          overflow: hidden;
          border-radius: inherit;
          background-color: #dddfec;
        }
      }

      em.team_red {
        span {
          float: right;
          background-color: #f45b63;
        }
      }

      em.team_blue {
        span {
          background-color: #4174f2;
        }
      }
    }

    dd.trans_half {
      strong {
        color: #999;
      }

      em.team_red {
        span {
          background-color: rgba(244, 91, 99, 0.5);
        }
      }

      em.team_blue {
        span {
          background-color: rgba(65, 116, 242, 0.5);
        }
      }
    }

    dt {
      flex-shrink: 0;
      width: 1.25rem;
      height: 100%;
      line-height: 0.32rem;
      overflow: hidden;
      font-size: 0.22rem;
      color: #333;
      text-align: center;
      text-overflow: ellipsis;
      white-space: nowrap;
      word-break: break-all;
    }
  }
}
</style>